import { RootState } from '@/store/types';
import { GetterTree } from 'vuex';
import { LoadingState } from './types';

export const getters: GetterTree<LoadingState, RootState> = {};
